import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.handler.subHandler.Ui.Pref.name), {
      handler: _ctx.handler.subHandler,
      onSubmitConfig: _ctx.submitConfig
    }, null, 40, ["handler", "onSubmitConfig"]))
  ]))
}